<template>
<!--  v-model="value"
    placeholder="请输入详细地址"
    @change="onChange"
    @search="changeAddr" -->
  <a-auto-complete
    :dropdown-menu-style="{width: '100%'}"
    option-label-prop="value"
    @select="changeSelect"
    @blur="onBlur"
  >
    <template slot="default">
      <div class="textWidth">
        <a-input v-model="value" :disabled="disabled" placeholder="请输入详细地址" :suffix="suffix"
          @change="onChange" @blur="onBlur" />
      </div>
    </template>
    <template slot="dataSource">
      <a-select-option
        v-for="item in data"
        :key="item.id"
        :value="item.id"
        :name="item.name"
      >
        <span>{{ item.name }}<span class="orig-address">{{ item.address }}-{{ item.typeLev3 }}</span></span>
      </a-select-option>
    </template>
  </a-auto-complete>
</template>
<script>
import _ from "lodash";
import { poiSearch } from "@/components/app-getAddress-BD/api.js";

const defaultWidth = 356
const maxWidth = 1440

export default {
  props: {
    defaultAddress: {
      type: String,
      default: "",
    },
    defaultSuffix: {
      type: String,
      default: "",
    },
    provinceText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    this.lastFetchId = 0;
    this.fetchUser = _.debounce(this.fetchUser, 800);
    this.changeAddr = _.debounce(this.changeAddr, 800);
    return {
      data: [],
      value: '',
      fetching: false,
      actRow: {},
      hasSelect: false,
      address: '',
      suffix: ''
    };
  },
  computed:{
    filterWidth(){
      const number = this.value.length * 14 + 40 + this.suffix.length * 14
      if(number > defaultWidth && number < maxWidth){
        return `${number}px`
      } 
      if(number <= defaultWidth) {
        return `${defaultWidth}px`
      }
      return `100%`
    }
  },
  watch:{
    defaultAddress:{
      handler(val){
        this.value = val.trim();
        this.address = val.trim();
      },
      immediate: true
    },
    defaultSuffix(val){
      this.suffix = val === ' ' ? '' : val;
    },
    value(val){
      if(val === ''){
        this.suffix = ''
        this.$emit("removeData", {}, {});
      }
    }
  },
  methods: {
    fetchUser(value) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.data = [];
      this.fetching = true;
      if (_.trim(value).length === 0) {
        this.$message.info("查询地址为空");
        this.fetching = false;
        return;
      }
      poiSearch({
        address: `${this.provinceText}${value}`,
        size: 50,
        city: this.provinceText,
      }).then((res) => {
        if (fetchId !== this.lastFetchId) {
          return;
        }
        this.data = res;
        this.fetching = false;
      });
    },
    changeAddr(val) {
      if (val) {
        if (_.trim(val).length === 0) {
          this.$message.info("查询地址为空");
          return;
        }
        poiSearch({
          address: `${this.provinceText}${val}`,
          size: 50,
          city: this.provinceText,
        }).then(res => {
          this.data = res;
        });
      } else {
       this.data = [];
      }
    },
    handleChange(value) {
      const actRow = this.data.filter((item) => item.id === value.key)[0];
      actRow.address = actRow.address.replace(this.provinceText,'')
      this.$emit("updateData", actRow);
      Object.assign(this, {
        value,
        data: [],
        fetching: false,
      });
    },
    changeSelect(value) {
      this.hasSelect = true;
      const actRow = this.data.filter((item) => item.id === value)[0] || {};
      this.value = actRow.name
      this.actRow = actRow
      const provinceText = `${actRow.province ||''}${actRow.city || ''}${actRow.county || ''}`
      this.data = []
      actRow.stationId = ''
      this.suffix = actRow.address || ''
      actRow.address = actRow.origAddress
      actRow.id = null
      this.$emit("updateData", actRow, provinceText);
    },
    onBlur() {
      
      // if (!this.actRow?.id) {
      //   const actRow = this.data[0] || {}
      //   if (actRow.id) {
      //     this.value = actRow.name
      //     this.actRow = actRow
      //     const provinceText = `${actRow.province ||''}${actRow.city || ''}${actRow.county || ''}`
      //     this.$emit("updateData", actRow, provinceText);
      //   } else {
      //     this.value = this.address
      //     this.$emit("updateAddress", this.value);
      //   }
      // } else if (!this.hasSelect) {
      //   this.value = this.address
      // }
      // this.data = []
    },
    onChange(val) {
      this.changeAddr(val.target.value)
      this.hasSelect = false;
      // const {actRow} = this;
      // if (actRow.id) {
      //   this.$emit("updateData", actRow, this.provinceText);
      // }
      // actRow.name = val;
    },
    clearData(){
      this.value = ''
      this.data = []
    }
  },
};
</script>
<style lang="less" scoped>
.select-wrapper{
  width: 100%;
}
.orig-address{
  margin-left: 10px;
  font-size: 12px;
  color: #ccc;
}
::v-deep .ant-input-suffix{
  color: #ccc !important;
}
.textWidth{
  ::v-deep .ant-input{
    min-width: 300px;
  }
}
::v-deep .ant-select-selection--single{
  box-shadow: none !important;
}
::v-deep .ant-input-suffix{
    max-width: 500px;
    height: 20px;
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
}
</style>
